import Portfolio from "../assets/projects/webp/portfolio.webp";

// import Whatsapp from "../assets/projects/webp/whatsapp.webp";
import CoffeShop from "../assets/projects/webp/coffeeShop.webp";
import Shape from "../assets/projects/webp/shape-commerce.webp";
import ShapeAdmin from "../assets/projects/webp/shape-admin.webp";
import Google from "../assets/projects/webp/google.webp";
import AVM from "../assets/projects/webp/avm.webp";
import Todo from "../assets/projects/webp/todo-mern.webp";
import ProdBoost from "../assets/projects/webp/prodboost.webp";
// import Scroll from "../assets/projects/webp/scroll.webp";
// import Charlie from "../assets/projects/webp/chatbot-charlie.webp";
import Hoobank from "../assets/projects/webp/hubnex.webp";
export const works = [
  {
    name: "HooBank",
    tags: ["nextjs"],
    link: "https://hoobankx.netlify.app/",
    // gLink: "https://github.com/SamirAhma/Focus-Academy",
    description: "",
    image: Hoobank,
    page: "https://rcx.netlify.app/posts/hoobank",
  },
  {
    name: "E-commerce",
    tags: ["fullstack", "react", "typescript", "express"],
    link: "https://shape-commerce.onrender.com/",
    gLink: "https://github.com/SamirAhma/shape-client/tree/main",
    image: Shape,
    page: "https://rcx.netlify.app/posts/shape-e-commerce",
  },
  {
    name: "E-commerce",
    tags: ["fullstack", "react", "typescript", "express"],
    link: "https://shape-admin.onrender.com",
    gLink: "https://github.com/SamirAhma/shape-admin/tree/main",
    image: ShapeAdmin,
    page: "https://rcx.netlify.app/posts/shape-admin-dashboard",
  },
  {
    name: "Gatsby E-Commerce",
    tags: ["react", "gatsby"],
    link: "https://joecoffee.netlify.app/",
    gLink: "https://github.com/SamirAhma/react-coffee-project",
    image: CoffeShop,
    page: "https://rcx.netlify.app/posts/coffes-shop",
  },
  {
    name: "Landing Page",
    tags: ["HTML", "CSS"],
    link: "https://avmconsulting.netlify.app/",
    gLink: "",
    image: AVM,
    page: "https://rcx.netlify.app/posts/landing-page",
  },
  // {
  //   name: "Portfolio",
  //   tags: ["gatsby"],
  //   link: "https://bellara.netlify.app/",
  //   gLink: null,
  //   image: Portfolio,
  //   page: "https://rcx.netlify.app/posts/resume-page",
  // },
  // {
  //   name: "Productivity Boost",
  //   tags: ["nextjs", "NetlifyCMS"],
  //   link: "https://prodboost.netlify.com/",
  //   gLink: "https://github.com/SamirAhma/elevate-your-life",
  //   image: ProdBoost,
  //   page: "https://rcx.netlify.app/posts/nextjs-blog",
  // },
  // {
  //   name: " Chat Application",
  //   tags: ["fullstack", "react", "express"],
  //   link: "https://adipchat.netlify.app/",
  //   gLink: "https://github.com/SamirAhma/adip-chat",
  //   image: Whatsapp,
  // },
  // {
  //   name: " Clone Google",
  //   tags: ["html"],
  //   link: "https://thriving-longma-76b55d.netlify.app/",
  //   gLink: "https://github.com/SamirAhma/gclone",
  //   image: Google,
  // },
  // {
  //   name: "Infinite Scroll",
  //   tags: ["react"],
  //   link: "https://genuine-moonbeam-c386bc.netlify.app/",
  //   gLink: "https://github.com/SamirAhma/Focus-Academy",
  //   image: Scroll,
  // },

  {
    name: " Todo App",
    tags: ["fullstack", "react", "typescript", "express"],
    link: "https://todo-mern-shape.onrender.com/",
    gLink: "https://github.com/SamirAhma/todolist",
    image: Todo,
    page: "https://rcx.netlify.app/posts/todo-app",
  },
  // {
  //   name: "Chatbot",
  //   tags: ["nextjs", "fullstack"],
  //   link: "https://chatbot-charlie.netlify.app/",
  //   // gLink: "https://github.com/SamirAhma/Focus-Academy",
  //   image: Charlie,
  // },
];
